export const reviewConstants = {
    LOADING_REVIEWS_REQUEST: '[Reviews] Load request',
    LOADING_REVIEWS_FAILURE: '[Reviews] Load failure',
    LOADING_REVIEWS_DONE: '[Reviews] Load done',
    UPDATE_REVIEWS: '[Reviews] Update',
}
